export class SetStatusDto {
  webDokuId = "";
  documentId = "";
  statusId = "";
}
